<div
  class="form-card-header flex items-center justify-between"
  [class.form-card-header--actions-only]="!showHeading"
>
  @if (showHeading) {
    <div class="form-card-header__main flex items-start gap-4 flex-1">
      @if (icon || logoUrl) {
        <div
          class="flex items-center justify-center shrink-0 w-11 h-11 rounded-xl transition-all duration-200"
          [ngClass]="
            icon ? 'bg-primary' : 'bg-surface border border-border shadow-sm'
          "
        >
          @if (icon) {
            <i
              [ngClass]="icon"
              class="text-[18px] text-on-primary inline-flex items-center justify-center"
            ></i>
          }
          @if (logoUrl) {
            <img
              [src]="logoUrl"
              alt="bank logo"
              class="w-[28px] h-[28px] object-contain"
            />
          }
        </div>
      }

      <div class="form-card-header__copy flex flex-col justify-center min-h-[40px]">
        @if (title) {
          <h2 class="form-card-header__title m-0">
            {{ title }}
          </h2>
        }
        @if (description) {
          <p class="form-card-header__description mt-0.5 mb-0">{{ description }}</p>
        }
      </div>
    </div>
  } @else if (title) {
    <h2 class="form-card-header__accessible-title">{{ title }}</h2>
  }

  <div class="form-card-header__actions flex items-center gap-2">
    <ng-content select="[card-actions]"></ng-content>
  </div>
</div>
